module.exports = __webpack_public_path__ + "assets/bar.0ef0583e.png";